import { render, staticRenderFns } from "./SurveillanceSymptoms.vue?vue&type=template&id=bfe1320e&scoped=true&"
import script from "./SurveillanceSymptoms.vue?vue&type=script&lang=js&"
export * from "./SurveillanceSymptoms.vue?vue&type=script&lang=js&"
import style0 from "./SurveillanceSymptoms.vue?vue&type=style&index=0&id=bfe1320e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe1320e",
  null
  
)

export default component.exports